module.exports = __webpack_public_path__ + "img/addText.1c3a94cf.svg";